import {
    Box,
    Checkbox,
    Divider,
    FormControlLabel,
    FormGroup,
    Paper,
    Typography,
} from '@mui/material';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const SERVER = process.env.REACT_APP_SERVER;

function LectureSelectionForm({ lectureId, selectedFees, total, onChange, feeError, errorRef }) {
    const [feeOptions, setFeeOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    //db에서 lecture_fees 불러오기
    useEffect(() => {
        axios
            .get(`${SERVER}/api/lecture/fee/${lectureId}`)
            .then((res) => {
                setFeeOptions(res.data);
                setLoading(false);
                setError(null);
            })
            .catch((err) => {
                setError('데이터 로드 실패');
                setLoading(false);
                console.log(err);
            });
    }, [lectureId]);

    //체크박스 선택/해제 핸들러
    const handleChange = (feeId, amount) => (e) => {
        let newFees;
        let newTotal;
        if (e.target.checked) {
            newFees = [...selectedFees, feeId];
            newTotal = total + Number(amount);
        } else {
            newFees = selectedFees.filter((id) => id !== feeId);
            newTotal = total - Number(amount);
        }
        const newNames = feeOptions.filter(f => newFees.includes(f.id)).map(f => f.fee_type);
        onChange(newFees, newTotal, newNames);
    };

    if (loading) return <div>로딩중...</div>;
    if (error) return <div>{error}</div>;

    return (
        <Box>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography mb={2} fontWeight="bold">
                    신청할 강의
                </Typography>
                {feeError && (
                    <Typography ref={errorRef} color="error" sx={{ mb: 1 }}>
                        강의를 하나이상 선택해주세요.
                    </Typography>
                )}
                <FormGroup>
                    {feeOptions.map((fee) => (
                        <Box
                            key={fee.id}
                            display="flex"
                            alignItems="flex-start"
                            mb={1}
                            sx={{ width: '100%' }}
                        >
                            {/* 체크박스+강의명: 75% */}
                            <Box sx={{ flexBasis: '75%', flexShrink: 1, flexGrow: 1, minWidth: 0 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedFees.includes(fee.id)}
                                            onChange={handleChange(fee.id, fee.amount)}
                                        />
                                    }
                                    label={
                                        <Typography
                                            sx={{
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-all',
                                                pr: 1,
                                            }}
                                        >
                                            {fee.fee_type}
                                        </Typography>
                                    }
                                    sx={{ alignItems: 'flex-start', m: 0 }}
                                />
                            </Box>
                            {/* 금액: 25% */}
                            <Box
                                sx={{
                                    flexBasis: '25%',
                                    flexShrink: 0,
                                    flexGrow: 0,
                                    textAlign: 'right',
                                    alignSelf: 'center',
                                    pl: 1,
                                }}
                            >
                                <Typography>{fee.amount.toLocaleString()} 원</Typography>
                            </Box>
                        </Box>
                    ))}
                </FormGroup>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <Typography fontWeight="bold">총 금액 :&nbsp;</Typography>
                    <Typography fontWeight="bold">{total.toLocaleString()} 원</Typography>
                </Box>
            </Paper>
        </Box>
    );
}

LectureSelectionForm.propTypes = {
    lectureId: PropTypes.number,
    selectedFees: PropTypes.array,
    total: PropTypes.number,
    onChange: PropTypes.func,
    feeError: PropTypes.bool,
    errorRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default LectureSelectionForm;
